import { deploymentProfile } from '../config/deploymentProfile';

const FONT_STYLE_ID = 'coplot-internal-fonts';
const FONT_BASE = '/fonts/internal';

const FACE_DEFINITIONS = [
  ['Regular', 400, 'normal'],
  ['Italic', 400, 'italic'],
  ['Medium', 500, 'normal'],
  ['MediumItalic', 500, 'italic'],
  ['Bold', 700, 'normal'],
  ['BoldItalic', 700, 'italic'],
];

function fontFaceCss([suffix, weight, style]) {
  return `
@font-face {
  font-family: 'Unica77 Cohere';
  src: url('${FONT_BASE}/Unica77CohereWeb-${suffix}.woff2') format('woff2'),
       url('${FONT_BASE}/Unica77CohereWeb-${suffix}.woff') format('woff');
  font-weight: ${weight};
  font-style: ${style};
  font-display: swap;
}`;
}

export function registerInternalFonts() {
  if (!deploymentProfile.isInternal || typeof document === 'undefined') return;
  if (document.getElementById(FONT_STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = FONT_STYLE_ID;
  style.textContent = FACE_DEFINITIONS.map(fontFaceCss).join('\n');
  document.head.appendChild(style);
}
